var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4520_5275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.86673 14.7319C5.86673 15.3735 6.1216 15.9888 6.57527 16.4425C7.02893 16.8962 7.64424 17.151 8.28582 17.151C8.92741 17.151 9.54271 16.8962 9.99638 16.4425C10.45 15.9888 10.7049 15.3735 10.7049 14.7319",
    stroke: "#B93823",
    strokeWidth: 1.09337,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84287 8.07992C2.84287 6.63636 3.41633 5.25192 4.43708 4.23117C5.45783 3.21042 6.84227 2.63696 8.28583 2.63696C9.7294 2.63696 11.1138 3.21042 12.1346 4.23117C13.1553 5.25192 13.7288 6.63636 13.7288 8.07992C13.7288 10.7878 14.3562 12.9635 14.8552 13.8253C14.9082 13.9171 14.9361 14.0211 14.9362 14.1271C14.9363 14.2331 14.9085 14.3372 14.8557 14.4291C14.8029 14.521 14.7268 14.5974 14.6352 14.6506C14.5436 14.7038 14.4395 14.7321 14.3336 14.7324H2.2381C2.13225 14.7318 2.02842 14.7034 1.93699 14.65C1.84556 14.5967 1.76973 14.5203 1.71708 14.4285C1.66443 14.3366 1.6368 14.2326 1.63696 14.1267C1.63712 14.0209 1.66507 13.9169 1.71799 13.8253C2.21618 12.9635 2.84287 10.787 2.84287 8.07992Z",
    stroke: "#B93823",
    strokeWidth: 1.09337,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4520_5275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.3071,
    height: 17.4939,
    fill: "white",
    transform: "translate(0.54361 0.450439)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.40a0fb783185287f581d19b86841bedb.svg";
export { ForwardRef as ReactComponent };